/** Stable comparison of persisted values; empty optional fields are equivalent. */
export function formSnapshot(value: unknown): string {
  const normalize = (item: unknown): unknown => {
    if (item === "" || item == null) return undefined;
    if (Array.isArray(item)) return item.map(normalize);
    if (typeof item === "object") {
      if ("toJSON" in item && typeof item.toJSON === "function") return normalize(item.toJSON());
      return Object.fromEntries(Object.entries(item).sort(([a], [b]) => a.localeCompare(b))
        .map(([key, entry]) => [key, normalize(entry)]).filter(([, entry]) => entry !== undefined));
    }
    return item;
  };
  return JSON.stringify(normalize(value)) ?? "";
}
